import { useMemo, useState } from "react";
import AnimationPlayerContainer from "@/domains/dev/animationPlayer/AnimationPlayerContainer.tsx";
import DevSelectorComponent from "@/domains/dev/components/DevSelectorComponent.tsx";
import ContentViewerContainer from "@/domains/dev/contentViewer/ContentViewerContainer.tsx";
import { ErrorHandlingContainer } from "@/domains/dev/errorHandling/ErrorHandlingContainer";
import EventFormContainer from "@/domains/dev/eventForm/EventFormContainer.tsx";
import EventListContainer from "@/domains/dev/eventList/EventListContainer.tsx";
import HouseCreatorContainer from "@/domains/dev/houseCreator/HouseCreatorContainer.tsx";
import ChatContainer from "@/domains/chat/containers/chat/ChatContainer";
import DeathScreenContainer from "@/domains/deathScreen/containers/DeathScreenContainer";
import EstateModalsContainer from "@/domains/estate/containers/modals/EstateModalsContainer";
import NotificationContainer from "@/domains/notification/containers/NotificationContainer";
import SpawnContainer from "@/domains/spawn/containers/SpawnContainer";

function DevContainer(): JSX.Element {
  const [currentContainer, setCurrentContainer] = useState<string | null>(null);

  const containersMap = useMemo(
    () => ({
      EventCefDebug: <ContentViewerContainer />,
      Animation: <AnimationPlayerContainer />,
      EventForm: <EventFormContainer />,
      EventList: <EventListContainer />,
      HouseCreator: <HouseCreatorContainer />,
      Spawn: <SpawnContainer />,
      Notification: <NotificationContainer />,
      HomeMenuModals: <EstateModalsContainer />,
      DeathScreen: <DeathScreenContainer />,
      Chat: <ChatContainer />,
      ErrorHandling: <ErrorHandlingContainer />,
    }),
    [],
  );

  let container = null;

  if (currentContainer) {
    container = containersMap[currentContainer];
  }

  return (
    <div className="fixed z-hud">
      {/* <ConfirmSubscriberContainer /> */}
      {/* <RadialMenuContainer /> */}
      {/* <InventoryContainer /> */}

      {/* <ConfiscationMainContainer /> */}
      {/* <VoiceChatContainer /> */}

      <DevSelectorComponent
        containers={Object.keys(containersMap)}
        currentContainer={currentContainer}
        setCurrentContainer={setCurrentContainer}
      />

      {container || ""}
    </div>
  );
}

export default DevContainer;
